// Shared helpers for all pages

export const PAYMENT_TYPES = ['cash', 'transfer', 'transfer_iran', 'credit', 'barter', 'service'];

export const today = () => new Date().toISOString().slice(0, 10);

/** Localized display name for products / raw materials (falls back to the main name). */
export const localName = (item, lang) => {
  if (!item) return '';
  if (lang === 'en' && item.name_en) return item.name_en;
  if (lang === 'ru' && item.name_ru) return item.name_ru;
  return item.name;
};

export const fmt = (n, digits = 2) => {
  const v = Number(n || 0);
  return v.toLocaleString('en-US', { maximumFractionDigits: digits });
};

export const money = (n) => (Number(n) < 0 ? `−$${fmt(-n)}` : `$${fmt(n)}`);

export const apiError = (e, t) => e?.response?.data?.detail
  ? (typeof e.response.data.detail === 'string' ? e.response.data.detail : t('error'))
  : t('error');

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const STOCK_BADGE = { in_stock: 'badge-green', low: 'badge-yellow', out: 'badge-red' };

/** Format an amount in a currency: 12,500,000 IRR / $1,250.50 */
export const cur = (n, code = 'USD') => (code === 'USD' ? money(n) : `${fmt(n, code === 'IRR' || code === 'UZS' ? 0 : 2)} ${code}`);
